module.exports = __webpack_public_path__ + "static/media/print-template1.9a5d88d5.png";